import objectPath from 'object-path'
import cloneDeep from 'clone-deep'

export const createApiGroup = (api) => {
  let newApi = cloneDeep(api)
  objectPath.del(newApi, 'tableData')
  objectPath.del(newApi, 'datasource')
  objectPath.del(newApi, 'column')
  objectPath.del(newApi, 'responseData')

  return newApi
}

export const createApiGroupList = (apiGroup = []) => {
  return apiGroup.map((api) => createApiGroup(api))
}

export const createApiCondition = createApiGroup

export const createApiConditionList = createApiGroupList
